import {
  stringToDate,
  isSameDay,
  isAfter,
  now,
  format,
  guessTZ,
  getTimeZoneAbbr,
  formatToTwoDigitsTimezone,
  FORMAT_MONTH_DAY_LONG,
  FORMAT_HOUR,
} from 'helpers/DateTimeHelper';

export const isDropped = (time, currentTime = now()) => isAfter(currentTime, stringToDate(time));
export const isCurrentDay = (time, currentTime = now()) =>
  isSameDay(stringToDate(time), currentTime);

export const getBroadcastDate = time => {
  let timezone = guessTZ();
  const date = stringToDate(time);
  if (!timezone || timezone.length < 3) {
    timezone = 'America/Los_Angeles';
  }
  const abbr = getTimeZoneAbbr(now(), 'z', timezone);
  const shortAbbr = formatToTwoDigitsTimezone(abbr);
  return `${format(date, FORMAT_MONTH_DAY_LONG)} at ${format(date, FORMAT_HOUR)} ${shortAbbr}`;
};

export const getRemainingTime = (time, currentTime = now()) => {
  const total = Date.parse(stringToDate(time)) - Date.parse(currentTime);
  return {
    days: Math.floor(total / (1000 * 60 * 60 * 24)),
    hours: Math.floor((total / (1000 * 60 * 60)) % 24),
    minutes: Math.floor((total / 1000 / 60) % 60),
    seconds: Math.floor((total / 1000) % 60),
    total,
  };
};

export const getMiddleColor = (hexColor1 = '#000000', hexColor2 = '#000000') => {
  const convertHexToDec = (numberString = '0') => parseInt(numberString, 16);
  const convertDecToHex = (number = 0) =>
    number < 16 ? `0${number.toString(16)}` : number.toString(16);

  const middleColor = {
    r:
      (convertHexToDec(hexColor1.substring(1, 3)) + convertHexToDec(hexColor2.substring(1, 3))) / 2,
    g:
      (convertHexToDec(hexColor1.substring(3, 5)) + convertHexToDec(hexColor2.substring(3, 5))) / 2,
    b:
      (convertHexToDec(hexColor1.substring(5, 7)) + convertHexToDec(hexColor2.substring(5, 7))) / 2,
  };
  const { r, g, b } = middleColor;
  return `#${convertDecToHex(r)}${convertDecToHex(g)}${convertDecToHex(b)}`;
};
